import React from 'react';

import { useTranslation } from 'react-i18next';
import {
  formatCommittmentCell,
  formatCustomerRateConditionCell,
  formatEquipmenSizeRateConditionCell,
  formatEquipmenTypeRateConditionCell,
  formatHazmatRateConditionCell,
  formatOrderTypeRateConditionCell,
  formatRateCell,
  formatReversibleCell,
  formatStatusCell,
  formatSteamshipLineRateConditionCell,
  formatUpdatedAtCell,
  formatValidityEnd,
  formatValidityStart,
} from './formatters';

import { RATE_CONDITION_COLUMN_PREFIX } from 'constants/LaneRates';

export const getColumns = () => {
  const { t } = useTranslation();

  return [
    {
      accessorKey: 'rate',
      header: () => <div className="text-right">Rate</div>,
      cell: formatRateCell,
    },
    {
      id: `${RATE_CONDITION_COLUMN_PREFIX}Customer`,
      header: () => <div className="w-36">{t('CUSTOMER')}</div>,
      cell: formatCustomerRateConditionCell,
    },
    {
      id: `${RATE_CONDITION_COLUMN_PREFIX}EquipmentType`,
      header: () => t('EQUIPMENT'),
      cell: formatEquipmenTypeRateConditionCell,
    },
    {
      id: `${RATE_CONDITION_COLUMN_PREFIX}EquipmentSize`,
      header: () => (
        <div className="text-right min-w-20">{t('EQUIP_SIZE')}</div>
      ),
      cell: formatEquipmenSizeRateConditionCell,
    },
    {
      id: `${RATE_CONDITION_COLUMN_PREFIX}Hazardous`,
      header: () => t('HAZARDOUS'),
      cell: formatHazmatRateConditionCell,
    },
    {
      id: `${RATE_CONDITION_COLUMN_PREFIX}OrderType`,
      header: () => <div className="min-w-20">{t('ORDER_TYPE')}</div>,
      cell: formatOrderTypeRateConditionCell,
    },
    {
      accessorKey: `${RATE_CONDITION_COLUMN_PREFIX}SteamshipOrRailroad`,
      header: () => t('STEAMSHIP_RAILROAD'),
      cell: formatSteamshipLineRateConditionCell,
    },
    {
      accessorKey: 'reversible',
      header: () => <div className="text-right">{t('REVERSIBLE')}?</div>,
      cell: formatReversibleCell,
    },
    {
      accessorKey: 'commitment',
      header: () => <div className="text-right">{t('COMMITMENT')}</div>,
      cell: formatCommittmentCell,
    },
    {
      accessorKey: 'effectiveStart',
      header: () => (
        <div className="min-w-24 text-right">{t('VALIDITY_START')}</div>
      ),
      cell: formatValidityStart,
    },
    {
      accessorKey: 'effectiveEnd',
      header: () => (
        <div className="min-w-24 text-right">{t('VALIDITY_END')}</div>
      ),
      cell: formatValidityEnd,
    },
    {
      accessorKey: 'status',
      header: () => t('STATUS'),
      cell: formatStatusCell,
    },
    {
      accessorKey: 'laneRatesUpdatedAt',
      header: () => t('UPDATED'),
      cell: formatUpdatedAtCell,
    },
  ];
};
